var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512.005 512.005",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f5d34f",
    d: "M395.18 172.366v201.52c0 27.26-22.18 49.44-49.44 49.44h-91.09l-57.06 39.8-69.95 48.8v-88.6h-78.2c-27.26 0-49.44-22.18-49.44-49.44v-201.52c0-27.27 22.18-49.44 49.44-49.44h296.3c27.26 0 49.44 22.17 49.44 49.44z",
    opacity: 1,
    "data-original": "#f5d34f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffa320",
    d: "M395.18 172.366v201.52c0 27.26-22.18 49.44-49.44 49.44h-91.09l-57.06 39.8v-340.2h148.15c27.26 0 49.44 22.17 49.44 49.44z",
    opacity: 1,
    "data-original": "#ffa320"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#619ced",
    d: "M500.776 65.516 303.31 262.983l-56.533 2.326 2.326-56.533L446.57 11.31c14.969-14.969 39.244-14.976 54.214-.007 7.481 7.481 11.229 17.296 11.222 27.103-.001 9.815-3.748 19.629-11.23 27.11z",
    opacity: 1,
    "data-original": "#619ced"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffa320"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.82 199.826h128.77v30H68.82zM68.82 258.056h128.77v30H68.82zM68.82 316.286h256.85v30H68.82z",
    fill: "#ffa320",
    opacity: 1,
    "data-original": "#ffa320"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4773cc",
    d: "M500.776 65.516 303.31 262.983l-56.533 2.326L500.783 11.303c7.481 7.481 11.229 17.296 11.222 27.103 0 9.815-3.747 19.629-11.229 27.11z",
    opacity: 1,
    "data-original": "#4773cc"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#514c7e",
    d: "m316.441 249.852-13.131 13.131-56.533 2.327 2.326-56.534 13.131-13.131z",
    opacity: 1,
    "data-original": "#514c7e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d2f5c",
    d: "m316.441 249.852-13.131 13.131-56.533 2.327 42.56-42.561z",
    opacity: 1,
    "data-original": "#2d2f5c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f78002",
    d: "M197.59 316.286h128.08v30H197.59z",
    opacity: 1,
    "data-original": "#f78002"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.160bac81ebc7f8521266f4993efd7f61.svg";
export { ForwardRef as ReactComponent };